import styled from 'styled-components';

export const ContentStyles = styled.div`
  width: 100%;
  margin: 180px auto 0;
  padding: 0 24px 24px;

  .phrase {
    position: relative;
    width: 100%;
    height: 90px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }

  .next-actions {
    margin: 16px auto 13px;
    max-width: max-content;
    padding: 0 0 20px;
    border-bottom: var(--success-payment-next-actions-border-bottom);

    &-title {
      padding: 0 0 12px;
      position: relative;
      margin: 0 auto 16px;
      width: max-content;

      &::after {
        content: '';
        z-index: 3;
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 4px;
        border-radius: 4px;
        background: linear-gradient(135deg, #7f36f3 0%, #ed0d80 100%);
      }
    }

    .next-action-description {
      margin: 0 0 14px;
    }
  }

  .questions-email {
    margin: 0 auto;

    a {
      color: inherit;
    }
  }
`;

export const WebVersionLinkStyles = styled.div`
  width: 100%;
  border-radius: 6px;
  border: 1px solid #a6a6a6;
  background: #000;
  color: #fff;
  padding: 8px 16px;
  max-width: 380px;
  width: 100%;
  margin: 0 auto 14px;

  a {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    color: inherit;
    font-weight: bold;
    text-decoration: none;

    ion-icon {
      font-size: 24px;
    }
  }
`;
